import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";


export const TeamAPI = async (setTeams, setTeamLeaderList, setCallerslist, setTeamslist, setLoading, currentPage, perpagedata, setPageCount, setIsReloadData)=>
{
    setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/sales/teams?page=" + currentPage + "&per_page=" + perpagedata);

        console.log("Data got successfully", response.data.teamcount);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setTeams(response.data.teams.data);
        setTeamLeaderList(response.data.teamleader);
        setCallerslist(response.data.callerslist);
        setTeamslist(response.data.teamslist);
        setLoading(false);
        setIsReloadData(false);
        //setIsCreateTeam(false);

        if(response.data.teams.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.teamcount / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const CreateTeamAPI = async (params, setCreateTeamPopup, setIsReloadData) =>
{    

    

    try 
    {
        const response = await baseapi.post('api/sales/team/create', params);

        //console.log("Data got successfully", response.data.mesg);

        setCreateTeamPopup(false);

        
        
        if(response.data.code == 200)
        {
            successMesg(response.data.mesg);

            setIsReloadData(true);
            
        }
        else
        {
            errorMesg(response.data.mesg);

            setIsReloadData(false);
        }

    } 
    catch (error) 
    {
        console.error("Error in caller invite:", error);

        setIsReloadData(false);
        //setLoading(false);
        errorMesg("Lead has not been updated. Please try again!!!");
    }

}

export const AssignTeamCallerAPI = async (params, setAddCallerTeamPopup, setIsReloadData) =>
{    

    

    try 
    {
        const response = await baseapi.post('api/sales/team/assign-callers', params);

        //console.log("Data got successfully", response.data.mesg);

        setAddCallerTeamPopup(false);

        
        
        if(response.data.code == 200)
        {
            successMesg(response.data.mesg);

            setIsReloadData(true);
            
        }
        else
        {
            errorMesg(response.data.mesg);
        }

    } 
    catch (error) 
    {
        console.error("Error in caller invite:", error);
        //setLoading(false);
        errorMesg("Callers has not been assigned to team. Please try again!!!");
    }

}

export const RemoveCallerFromTeamAPI = async (params, setIsReloadData, setShowDeleteModal) =>
{    

    
    console.log('+++++' + JSON.stringify(params));
    try 
    {
        const response = await baseapi.post('api/sales/team/remove-caller', params);

        //console.log("Data got successfully", response.data.mesg);

        //setAddCallerTeamPopup(false);

        setShowDeleteModal(false);
        
        if(response.data.code == 200)
        {
            successMesg(response.data.mesg);

            setIsReloadData(true);

        }
        else
        {
            errorMesg(response.data.mesg);
        }

    } 
    catch (error) 
    {
        setShowDeleteModal(false);

        console.error("Error in caller invite:", error);
        //setLoading(false);
        errorMesg("Callers has not been assigned to team. Please try again!!!");
    }

}


